'use client';

import { useSyncExternalStore } from 'react';

import {
  resolveViewportClass,
  type ViewportClass,
} from './viewport-class.consts';
import {
  subscribeWindowResize,
  useHasMounted,
} from './viewport-subscription.utils';

export { resolveViewportClass, type ViewportClass };

const getViewportClass = () => resolveViewportClass(window.innerWidth);

export function useViewportClass(): {
  viewportClass: ViewportClass;
  mounted: boolean;
} {
  const viewportClass = useSyncExternalStore(
    subscribeWindowResize,
    getViewportClass,
    () => 'mobile' as const
  );

  const mounted = useHasMounted();

  return { viewportClass, mounted };
}
